import { useState, useContext } from 'react'

import { LoginContext, logoutAction } from '../../pages/login/login-gate';

import { Button } from '../button/button';
import { ContextMenu } from '../context-menu/context-menu';

function ContextMenuContent(props) {
    const loginContext = useContext(LoginContext);

    return (
        <>
        {props.children}
        <Button
            variant="label"
            icon="ic_exit"
            clicked={() => loginContext.dispatch(logoutAction())} >
            Log out
        </Button>
        </>
    );
}

export function PageMenu(props) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <ContextMenu
            content={<ContextMenuContent {...props} />}
            open={menuOpen}
            closed={() => setMenuOpen(false)}>
            <Button
                variant="icon"
                icon="ic_sidebar"
                size="large"
                clicked={() => setMenuOpen(!menuOpen)}>
            </Button>
        </ContextMenu>
    );
}